import React from 'react';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';


const AddressSection = ({ formData, errors, onChange, onAddAddress, onRemoveAddress }) => {
  return (
    <div className="bg-card rounded-lg border border-border p-6">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-semibold text-foreground">
          Endereço
          <span className="text-error ml-1">*</span>
        </h2>
        <Button
          variant="outline"
          size="sm"
          onClick={onAddAddress}
          iconName="Plus"
          iconPosition="left"
        >
          Adicionar endereço
        </Button>
      </div>
      <div className="space-y-6">
        {formData?.addresses?.map((address, index) => (
          <div key={index} className="border border-border rounded-lg p-4 relative">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-md font-medium text-foreground">
                {index === 0 ? 'Endereço principal' : `Endereço ${index + 1}`}
              </h3>
              {formData?.addresses?.length > 1 && (
                <Button
                  variant="outline"
                  size="sm"
                  onClick={() => onRemoveAddress(index)}
                  iconName="Trash2"
                  className="text-error hover:text-error"
                />
              )}
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="md:col-span-2">
                <Input
                  label="Endereço"
                  type="text"
                  placeholder="Digite o endereço"
                  value={address?.street}
                  onChange={(e) => onChange('addresses', formData?.addresses?.map((addr, i) => 
                    i === index ? { ...addr, street: e?.target?.value } : addr
                  ))}
                  error={errors?.addresses && errors?.addresses?.[index] && errors?.addresses?.[index]?.street}
                  required={index === 0}
                />
              </div>
              
              <Input
                label="Cidade"
                type="text"
                placeholder="Digite a cidade"
                value={address?.city}
                onChange={(e) => onChange('addresses', formData?.addresses?.map((addr, i) => 
                  i === index ? { ...addr, city: e?.target?.value } : addr
                ))}
                error={errors?.addresses && errors?.addresses?.[index] && errors?.addresses?.[index]?.city}
                required={index === 0}
              />
              
              <Input
                label="Estado"
                type="text"
                placeholder="Digite o estado"
                value={address?.state}
                onChange={(e) => onChange('addresses', formData?.addresses?.map((addr, i) => 
                  i === index ? { ...addr, state: e?.target?.value } : addr
                ))}
                error={errors?.addresses && errors?.addresses?.[index] && errors?.addresses?.[index]?.state}
                required={index === 0}
              />
              
              <Input
                label="CEP"
                type="text"
                placeholder="Digite o CEP"
                value={address?.zipCode}
                onChange={(e) => onChange('addresses', formData?.addresses?.map((addr, i) => 
                  i === index ? { ...addr, zipCode: e?.target?.value } : addr
                ))}
                error={errors?.addresses && errors?.addresses?.[index] && errors?.addresses?.[index]?.zipCode}
                required={index === 0}
              />
              
              <Input
                label="Tipo de endereço"
                type="text"
                placeholder="Residencial/Comercial/Outro"
                value={address?.type}
                onChange={(e) => onChange('addresses', formData?.addresses?.map((addr, i) => 
                  i === index ? { ...addr, type: e?.target?.value } : addr
                ))}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AddressSection;